import React from 'react';

import { useSelector } from 'react-redux';

import { PredictionPanel } from './PredictionPanel';
import { PredictionPanelContainerProps } from './types';
import { getCareerGuidanceOptions } from '../../../../constants/ResultData';
import { selectIsDesktop } from '../../../../store/settingsSlice/settingsSelectors';
import { cacheImages } from '../../../../utils/cacheImages';

const PredictionPanelContainer: React.FC<PredictionPanelContainerProps> = ({ id }) => {
  const isDesktop = useSelector(selectIsDesktop);
  const temperamentOptions = getCareerGuidanceOptions();
  let imagesToCash = Object.values(temperamentOptions).map(
    ({ famousPersons }: any) => famousPersons.map(({ image }: any) => image)
  ).flat(1);
  cacheImages(imagesToCash);

  imagesToCash = Object.values(temperamentOptions).map(
    ({ image }: any) => Object.values(image).map((item: any) => item.props.src)).flat(1);
  cacheImages(imagesToCash);

  return (
    <PredictionPanel id={id} isDesktop={isDesktop} />
  );
};

export default PredictionPanelContainer;
